export const ALGO_TYPES = {
    DEFAULT: 'Default',
    SHIPPER_GLOBAL_DEFAULT: 'Default',
    CARRIER_GLOBAL_DEFAULT: 'Default',
    ONWARD_CONSOLIDATED: 'Onward v2',
    LIVING_SPACES: 'Living Spaces',
    ROCKET_SHIPPING: 'Rocket Shipping',
    WERNER_CARRIER_DEFAULT: 'Werner Agent',
    CUSTOMCO: 'Custom Global',
    CXT_API: 'Elite Transportation Systems',
};

/** Onward v2 built-in service levels: rate type prefix → label. */
export const SERVICE_LEVELS = {
    CURBSIDE_NO_CONTACT: 'Dock / Curbside - No Contact',
    CURBSIDE_NO_CONTACT_2MAN: '2 Man Dock / Curbside - No Contact',
    CURBSIDE: 'Dock / Curbside',
    CURBSIDE_2MAN: '2 Man Dock / Curbside',
    THRESHOLD: 'Threshold / First Dry Space',
    THRESHOLD_2MAN: '2 Man Threshold / First Dry Space',
    ROOM_OF_CHOICE: 'Room of Choice',
    ROOM_OF_CHOICE_2MAN: '2 Man Room of Choice',
    WHITE_GLOVE: 'White Glove',
    WHITE_GLOVE_2MAN: '2 Man White Glove',
    WHITE_GLOVE_ASSEMBLY: 'White Glove w/ Assembly',
    WHITE_GLOVE_ASSEMBLY_2MAN: '2 Man White Glove w/ Assembly',
};

/** Onward v2 accessorials priced per service level (the rate type is prefixed with the service level). */
export const SERVICE_ACCESSORIALS = [
    { label: 'Additional Items', type: 'ITEMS_INCREMENTAL_RATE', adornment: '$', decorator: '/item' },
    { label: 'Additional Cabinets', type: 'CABINETS_INCREMENTAL_RATE', adornment: '$', decorator: '/unit' },
    { label: 'Labor', type: 'LABOR_INCREMENTAL_RATE', adornment: '$', decorator: '/increment', min: 'minutes' },
    { label: 'Labor Max', type: 'LABOR_MAX_RATE', adornment: '$', decorator: 'max' },
    { label: 'Labor Increments', type: 'LABOR_INCREMENTS', adornment: '', decorator: 'minutes', omitTag: true },
    { label: 'Stop Adjustment', type: 'STOP_ADJUSTMENT', adornment: '$', decorator: '/stop' },
];

/** Onward v2 accessorials shared by every service level. */
export const COMMON_ACCESSORIALS = [
    { label: 'Stairs', type: 'STAIRS_BASE_RATE', adornment: '$' },
    {
        label: 'Additional Stairs',
        type: 'STAIRS_INCREMENTAL_RATE',
        adornment: '$',
        decorator: '/flight',
        min: 'flights',
    },
    {
        label: 'Additional Stairs by Weight',
        type: 'STAIRS_WEIGHT_RATE',
        adornment: '$',
        decorator: '/lb /flight',
        min: 'flights',
    },
    { label: 'Stairs Min', type: 'STAIRS_MIN_RATE', adornment: '$', decorator: 'min' },
    {
        label: 'Stairs (Cabinets)',
        type: 'STAIRS_CABINET_RATE',
        adornment: '$',
        decorator: '/unit /flight',
        min: 'flights',
    },
    { label: 'Storage', type: 'STORAGE_INCREMENTAL_RATE', adornment: '$', decorator: '/day', min: 'days' },
    { label: 'Storage Max', type: 'STORAGE_MAX_RATE', adornment: '$', decorator: '/month' },
    { label: 'Storage (Cabinets)', type: 'STORAGE_CABINET_RATE', adornment: '$', decorator: '/unit /day', min: 'days' },
    { label: 'Haulaways', type: 'HAULAWAYS_BASE_RATE', adornment: '$' },
    {
        label: 'Additional Haulaways',
        type: 'HAULAWAYS_INCREMENTAL_RATE',
        adornment: '$',
        decorator: '/item',
        min: 'items',
    },
    {
        label: 'Additional 3rd Person',
        type: '3_MAN_TEAM_RATE',
        adornment: '$',
    },
    { label: 'Packing Flat', type: 'PACKING_BASE_RATE', adornment: '$' },
    { label: 'Packing by Volume', type: 'PACKING_VOLUME_RATE', adornment: '$', decorator: '/cu ft' },
    { label: 'Packing Min', type: 'PACKING_MIN_RATE', adornment: '$', decorator: 'min' },
    { label: 'Pickup Fee', type: 'PICKUP_RATE', adornment: '$' },
    { label: 'Airline', type: 'AIRLINE_BASE_RATE', adornment: '$' },
    {
        label: 'Fuel Surcharge',
        type: 'FUEL_PRICE_MODIFIER',
        adornment: '%',
        isPercentage: true,
        decorator: 'of subtotal',
    },
    {
        label: 'Exchange (percentage)',
        type: 'EXCHANGE_MODIFIER_RATE',
        adornment: '%',
        isPercentage: true,
        decorator: 'of freight charge',
    },
    { label: 'Exchange (flat)', type: 'EXCHANGE_FLAT_RATE', adornment: '$' },
    {
        label: 'Attempt (percentage)',
        type: 'ATTEMPT_MODIFIER_RATE',
        adornment: '%',
        isPercentage: true,
        decorator: 'of freight charge',
    },
    { label: 'Attempt (flat)', type: 'ATTEMPT_FLAT_RATE', adornment: '$' },
    {
        label: 'Cancellation (percentage)',
        type: 'CANCELLATION_MODIFIER_RATE',
        adornment: '%',
        isPercentage: true,
        decorator: 'of freight charge',
    },
    { label: 'Cancellation (flat)', type: 'CANCELLATION_FLAT_RATE', adornment: '$' },
    {
        label: 'Will Call (percentage)',
        type: 'WILL_CALL_MODIFIER_RATE',
        adornment: '%',
        isPercentage: true,
        decorator: 'of freight charge',
    },
    { label: 'Will Call (flat)', type: 'WILL_CALL_FLAT_RATE', adornment: '$' },
    {
        label: 'Additional Primary Rate',
        type: 'ADDITIONAL_PRIMARY_RATE',
        adornment: '$',
        decorator: 'additional',
    },
    {
        label: 'Additional Secondary Rate',
        type: 'ADDITIONAL_SECONDARY_RATE',
        adornment: '$',
        decorator: 'additional',
    },
];
